import { render, staticRenderFns } from "./SelfInflictInjury.vue?vue&type=template&id=8d72e616&scoped=true"
import script from "./SelfInflictInjury.vue?vue&type=script&lang=js"
export * from "./SelfInflictInjury.vue?vue&type=script&lang=js"
import style0 from "./SelfInflictInjury.vue?vue&type=style&index=0&id=8d72e616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d72e616",
  null
  
)

export default component.exports